module.exports = __webpack_public_path__ + "src/assets/img/logo-car-x.95fbc480.svg";